<template>
  <base-dialog-form type="dialog" ref="insertPuntiGaraDialog" :title="votiGara ? votiGara.ragSoc : ''"
    :text="votiGara ? votiGara.titolo : ''" color="secondary" :icon="votiGara && votiGara.type === 'P'
      ? 'mdi-chart-scatter-plot'
      : 'mdi-timer-outline'
      ">
    <template v-slot:actions>
      <v-col cols="12" class="text-center">
        <v-btn class="mx-5" v-if="toSave" @click="saveVote" color="success">
          <h3>
            {{
              $t("vote") + " " + realTimeVotiGara.totale + " " + $t("points")
            }}
          </h3>
        </v-btn></v-col>
    </template>
    <v-container v-if="votiGara">
      <v-row v-if="votiGara.tabellaVoti && votiGara.ifGiudiceGara">
        <div v-for="voto in votiGara.tabellaVoti" :key="voto.idSchedaDettaglio" style="margin:10px;">
          <h4 class="success--text headline">
            {{ getTranslations(voto, "name") }}
          </h4>
          <span>{{ getTranslations(voto, "descr") }}</span>

          <v-col cols="12" v-if="votiGara.type === 'P'">
            <v-btn style="margin: 10px" v-for="index in voto.maxPoint" :key="index" :disabled="voto.saved ? true : false"
              @click="voto.score = index" fab x-large class="vote-button">
              <v-avatar :color="voto.saved && voto.score !== index
                ? '#999'
                : voto.score && voto.score == index
                  ? 'success'
                  : 'primary'
                " size="100%" :style="voto.score ? 'margin: 10px' : 'margin: 0px'">
                <span class="white--text headline">{{ index }}</span>
              </v-avatar>
            </v-btn>
          </v-col>

          <v-col cols="12" v-else>
            <v-text-field v-model="voto.score" v-mask="mask" outlined large :disabled="voto.saved ? true : false"
              type="text" append-color="success" append-icon="mdi-send"
              :label="$t('insert_time_hh_mm_ss_micro')"></v-text-field>
          </v-col>

          <v-divider></v-divider>

        </div>
      </v-row>

      <v-row v-if="votiGara.tabellaPenalita &&
        (votiGara.ifGiudiceGara || votiGara.ifGiudicePenalita)
        ">
        <v-col cols="12" v-for="voto in votiGara.tabellaPenalita" :key="voto.name" style="margin-top: 10px;">
          <v-row>
            <v-col>
              <v-card style="
                  padding: 10px;
                  min-width: 150px;
                  text-align: center;
                  margin: 0px 15px 15px 15px;
                  height: 50px;
                " color="error" dark>
                <v-btn v-if="!voto.saved" icon large color="white" min-width="0" style="float: left; height: 32px"
                  @click.native="deletePenalty(voto)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <h1>{{ voto.score }}</h1>
              </v-card>
            </v-col>
            <v-col>
              <h4 class="error--text headline">{{ $t("penalty") }}</h4>
              <h4>{{ voto.descr }}</h4>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-col>
        <v-container v-if="!votiGara.saved || toSave">
          <v-row>
            <v-col md="8" sm="12">
              <v-text-field v-model="testoPenalita" :label="$t('text_penalty')" :rules="required"
                type="text"></v-text-field></v-col>
            <v-col md="2" sm="12">
              <v-text-field v-model="valuePenalita" :label="$t('value_penalty')" :rules="requiredNumber"
                type="number"></v-text-field>
            </v-col>
            <v-col md="2" sm="12">
              <v-btn style="margin: 0 10px; float: left" fab color="error" x-small @click="addPenalty">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <h4 class="error--text headline">{{ $t("insert_penalty") }}</h4>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>

<script>
import Swal from "sweetalert2";
import { mask } from "vue-the-mask";
export default {
  name: "insert-punti-gara",
  directives: {
    mask,
  },
  data() {
    return {
      idGara: null,
      idGaraPartecipanti: null,
      masterId: null,
      testoPenalita: null,
      valuePenalita: null,
      mask: "XX:XX:XX:XXXXX",
      votiGara: null,
      required: [(value) => !!value || this.$t("required")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  computed: {
    toSave: function () {
      if (!this.votiGara) return false;
      for (let voto of this.votiGara.tabellaVoti) {
        if (!voto.saved || voto.saved === false) return true;
      }
      for (let voto of this.votiGara.tabellaPenalita) {
        if (!voto.saved || voto.saved === false) return true;
      }
      return false;
    },
    realTimeVotiGara: function () {
      let votiReal = { totVoti: 0, totPenalita: 0, totale: 0 };
      if (!this.votiGara) return votiReal;
      for (let voto of this.votiGara.tabellaVoti) {
        if (voto.score) votiReal.totVoti = votiReal.totVoti + voto.score;
      }
      for (let voto of this.votiGara.tabellaPenalita) {
        if (voto.score)
          votiReal.totPenalita = votiReal.totPenalita + voto.score;
      }
      votiReal.totale = votiReal.totVoti - votiReal.totPenalita;
      return votiReal;
    },
  },
  methods: {
    getTranslations(voto, type) {
      let locale = localStorage.getItem("selectedLanguage");
      window.navigator.userLanguage || window.navigator.language;
      if (!locale) {
        locale = window.systemData.defaultLanguage;
      }
      if (type === "name") {
        return voto.nameTranslations &&
          voto.nameTranslations[locale] &&
          voto.nameTranslations[locale] !== ""
          ? voto.nameTranslations[locale]
          : voto.name;
      }
      if (type === "descr") {
        return voto.descrTranslations &&
          voto.descrTranslations[locale] &&
          voto.descrTranslations[locale] !== ""
          ? voto.descrTranslations[locale]
          : voto.descr;
      }
      return "????";
    },
    addPenalty() {
      let _ = this;
      if (
        _.testoPenalita &&
        _.testoPenalita !== "" &&
        _.valuePenalita &&
        _.valuePenalita >= 0
      ) {
        let maxId = 0;
        for (let penalita of _.votiGara.tabellaPenalita) {
          if (penalita.idGareVoti > maxId) maxId = penalita.idGareVoti;
        }
        maxId++;
        _.votiGara.tabellaPenalita.push({
          descr: _.testoPenalita,
          idGareVoti: maxId,
          name: _.testoPenalita,
          score: parseInt(_.valuePenalita),
          type: "P",
        });
      }
    },
    deletePenalty(item) {
      if (this.votiGara) {
        this.votiGara.tabellaPenalita = this.votiGara.tabellaPenalita.filter(
          (penalita) => {
            return penalita.idGareVoti !== item.idGareVoti;
          }
        );
      }
    },
    open(idGara, idGaraPartecipanti) {
      this.masterId = parseInt(window.myData.masterId);
      this.idGara = idGara;
      this.idGaraPartecipanti = idGaraPartecipanti;
      this.loadData();
      this.$refs.insertPuntiGaraDialog.open();
    },
    loadData(afterSave = false) {
      let _ = this;
      _.testoPenalita = null;
      _.valuePenalita = null;
      let url =
        "/auth/eventi/getGaraVoti/" + _.idGara + "/" + _.idGaraPartecipanti;
      _.chiamataAxios("GET", url).then((response) => {
        _.votiGara = response.data;
        if (afterSave && !_.toSave) _.$refs.insertPuntiGaraDialog.close();
      });
    },
    saveVote() {
      let _ = this;
      let testo =
        '<br><h3 style="width: 100%;" class="success--text">' +
        _.$t("score") +
        ": " +
        _.realTimeVotiGara.totale +
        "</h3>" +
        '<br><h3 style="width: 100%" class="primary--text">' +
        _.$t("partial_score") +
        ": " +
        _.realTimeVotiGara.totVoti +
        "</h3>" +
        '<br><h3 style="width: 100%; " class="error--text">' +
        _.$t("penalty") +
        ": " +
        _.realTimeVotiGara.totPenalita +
        "</h3>";
      let votazioni = _.votiGara.tabellaVoti
        .filter((voto) => {
          return !voto.saved;
        })
        .concat(
          _.votiGara.tabellaPenalita.filter((voto) => {
            return !voto.saved;
          })
        );

      Swal.fire({
        title: _.$t("are_you_sure_?"),
        html: testo,
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: _.$t("vote"),
        cancelButtonText: _.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "PUT",
            "/auth/eventi/setPunteggioGara/" +
            _.idGara +
            "/" +
            _.idGaraPartecipanti,
            { dialogLodaer: true, body: votazioni }
          ).then((response) => {
            if (response.msg.esito) {
              _.$emit("isUpdated", "true");
              _.loadData(true);
            }
          });
        }
      });
    },
  },
};
</script>
<style >
.vote-button .v-btn__content {
  width: 100%;
  height: 100%;
}
</style>